/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Panel, PanelProps } from 'react-resizable-panels'

export const ResizablePanel = (props: PanelProps) => {
	return (
		<Panel {...props} css={style}>
			{props.children}
		</Panel>
	)
}

const style = css({
	display: 'flex',
	flexDirection: 'column',
})
